const REVERT_MESSAGE =
  'After you delete a group, users revert to their individually assigned permissions.';

export const getGroupDeleteBody = (count: number | undefined): string => {
  if (count === undefined) {
    return REVERT_MESSAGE;
  }
  const noun = count === 1 ? 'user' : 'users';
  return `This group has ${count} ${noun}. ${REVERT_MESSAGE}`;
};
